module.exports = __webpack_public_path__ + "img/logo-alone@2x.98386b2.png";